import React from 'react';
import { Nav } from 'rsuite';
import { Link } from 'react-router-dom';
import { PARTNER_SETUP } from '../../routes/links';

type Tab = 'mpi' | 'platform' | 'feed';

function getTo(tab: Tab): string {
  return `${PARTNER_SETUP}/${tab}`;
}

interface NavItemProps {
  tab: Tab;
  children: React.ReactNode;
}

function NavItem({ tab, children }: NavItemProps): React.ReactElement {
  return (
    <Nav.Item
      key={tab}
      eventKey={tab}
      as={Link}
      to={getTo(tab)}
    >
      {children}
    </Nav.Item>
  );
}

interface Props {
  tab: 'mpi' | 'platform' | 'feed';
}

export default function PartnerSetupNavigation({ tab } : Props) {
  return (
    <Nav activeKey={tab} appearance="subtle">
      <NavItem tab="mpi">MPI setup</NavItem>
      <NavItem tab="platform">Platform setup</NavItem>
      <NavItem tab="feed">Feed sync</NavItem>
    </Nav>
  );
}
